const BaseModule = require('../../90_utils/base/BaseModule');

class LoopingVideo extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$video = this.$el.find('.video');
		this.$poster = this.$el.find('.poster');

		this.iframeURL;

		this.isEnabled = false;
		this.isPlaying = false;
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){

		this.$el.on('viewportEnter', $.proxy(this._onViewportEnter, this));
		this.$el.on('viewportLeave', $.proxy(this._onViewportLeave, this));
	}

	_removeListeners(){

		this.$video.off('playing', $.proxy(this._onBufferComplete, this));
		this.$video.off('canplaythrough', $.proxy(this._onBufferComplete, this));

		this.$el.off('viewportEnter', $.proxy(this._onViewportEnter, this));
		this.$el.off('viewportLeave', $.proxy(this._onViewportLeave, this));
	}

	//

	_onViewportEnter(){
		this.isPlaying = true;
		this._play();
	}

	_onViewportLeave(){
		this.isPlaying = true;
		this._pause();
	}

	_buffer(){

		this.$video.on('playing', $.proxy(this._onBufferComplete, this));
		this.$video.on('canplaythrough', $.proxy(this._onBufferComplete, this));

		this.$el.addClass('is-buffering');
		// this.$video[0].pause();
	}

	_onBufferComplete(){

		this.$video.off('playing', $.proxy(this._onBufferComplete, this));
		this.$video.off('canplaythrough', $.proxy(this._onBufferComplete, this));

		this.$el.removeClass('is-buffering');
		this.$el.addClass('is-buffered');

		if(this.isEnabled && this.isPlaying){
			this._play();
		}
	}

	//

	_checkStatus(){

		console.log(this.isEnabled, this.isPlaying);

		if(this.isEnabled && this.isPlaying){
			this._play();
		}
		else {
			this._pause();
		}
	}

	//

	_play(){

		if(this.isEnabled){

			if(!this.$el.hasClass('is-buffering')){

				// this.$video[0].play();

				if(!this.$el.hasClass('is-buffered')){
					this._buffer();
				}
			}
		}
	}

	_pause(){
		// this.$video[0].pause();
		this.isPlaying = false;
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){

	}

	_domUpdate(){

	}
	_resize(){

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			this.isEnabled = true;

			if(this.iframeURL){
				this.$el.find('iframe').attr('src', this.iframeURL);
			}
		}
		else {

			this.isEnabled = false;

			if(!this.iframeURL){
				this.iframeURL = this.$el.find('iframe').attr('src');
			}

			this.$el.find('iframe').attr('src', '');
		}

		let videoHeight = this.$el.outerHeight() * 1.04;
		let topBleed = this.$el.outerHeight() * 0.04 / 2;
		let classes = this.$el.find('.video .scaler').attr('class');
		let ratioSplit = classes.split('scaler-')[1].split('x');
		let aspectRatio = ratioSplit[0] / ratioSplit[1];

		this.$el.find('.video').css({
			top: 0 - topBleed,
			left: Math.round((window.SETTINGS.coords.viewportWidth - videoHeight * aspectRatio)/2),
			width: Math.round(videoHeight * aspectRatio),
			height: videoHeight
		});

		this._checkStatus();
	}
}

module.exports = LoopingVideo;
